import { Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { BehaviorSubject, Observable, Subject, takeUntil } from 'rxjs';
import { IndexDbService } from './index-db.service';
import { Config } from '../_interfaces/config.interface';

@Injectable({
    providedIn: 'root',
})

export class CacheService {

    public configSubject = new BehaviorSubject<Config | null>(null);
    public config$: Observable<Config | null> = this.configSubject.asObservable();
    unSubscribe = new Subject<void>();
    public config: Config | any = {};
    languageCodes: WritableSignal<string[]> = signal([]);

    constructor() {
        this.getBlogs();
    }

    getBlogs() {
        // this.idb.blogs$.pipe(takeUntil(this.unSubscribe)).subscribe((blogs: JsBlog[] | null) => {
        //     if (blogs) {
        //         const activeBlogs: JsBlog[] = [];
        //         blogs.forEach(blog => {
        //             if (!blog.deletedAt) {
        //                 activeBlogs.push(blog);
        //             }
        //         });
        //         this.blogsSubject.next(blogs);
        //     }
        // });
    }

    stopSubscription() {
        this.unSubscribe?.next();
        this.unSubscribe?.complete();
    }
}
